import { useEffect, useRef } from "react";
import { PropTypes } from "prop-types";
import { matchPath, useLocation } from "react-router-dom";
import AppHOC from "../../../generics/AppHOC";
import { useMount } from "../../../utils/genericCommon";
import { isCustom } from "../../../utils/common";
import { getApplicationsTableList } from "../../../utils/views/applications";
import { routeURLs } from "../../../utils/enums";
import apiService from "../../../config/api-config";

const MasterTable = ({
  setAppsWithFamilySLA,
  setAggregateAppData,
  globalFilter: filter,
}) => {
  const location = useLocation();
  const mount = useMount();
  const dataRef = useRef({
    query: {},
    queryString: "",
  });

  useEffect(() => {
    const runEffect = async () => {
      if (
        !matchPath({ path: routeURLs.overview }, location.pathname) ||
        !mount.mounted
      )
        return;
      const timePeriodSelected = filter.timePeriodSelected;
      const query = {
        overlayId: localStorage.getItem("currentOverlay"),
        timeFilterType: timePeriodSelected,
        timeRange: filter.timeFilter.current_period.slice(0),
        timestamp: filter.currentTimeStamp,
        siteId: filter.selectedSite,
        nhName: filter.selectedNhName || null,
      };
      const queryString = JSON.stringify(query);
      query.preTimeRange = filter.timeFilter.previous_period.slice(0);
      const initMount = mount.initMount;
      mount.initMount = false;
      if (!localStorage.getItem("currentOverlay")) return;
      if (
        !(isCustom(timePeriodSelected) && !filter.selectedCustomTime) &&
        (initMount || queryString !== dataRef.current.queryString)
      ) {
        dataRef.current.query = query;
        dataRef.current.queryString = queryString;
        const payload = { ...filter.globalV4Payload, sort: { usage: "desc" } };
        setAppsWithFamilySLA(undefined);
        const res = await apiService.getTableCustomList(payload);
        if (!mount.mounted || queryString !== dataRef.current.queryString)
          return;
        if (!res.errorObject) {
          const tableList = getApplicationsTableList(res.data);
          setAppsWithFamilySLA(tableList);
          setAggregateAppData(res);
        } else {
          setAggregateAppData(res);
          setAppsWithFamilySLA([]);
        }
      }
    };

    runEffect();
  }, [
    filter.selectedOverlay,
    filter.timePeriodSelected,
    filter.timeFilter.current_period[0],
    filter.timeFilter.current_period[1],
    filter.currentTimeStamp,
    location.pathname,
    filter.selectedSite,
    filter.selectedNhName,
  ]);

  return null;
};

MasterTable.propTypes = {
  globalFilter: PropTypes.object.isRequired,
  setAppsWithFamilySLA: PropTypes.func.isRequired,
  setAggregateAppData: PropTypes.func.isRequired,
};

export default AppHOC(MasterTable);
